module.exports = __webpack_public_path__ + "static/media/class1-mins.5d3bc9bd.png";